import gallery from "../components/gallery/gallery";
import collapsibleText from "../components/collapsibleText/collapsibleText";

export default {
    name: 'components',
    label: 'Komponendid',
    create: false,
    i18n: {
        structure: 'single_file',
    },
    files: [gallery, collapsibleText],
};